export {
  cut,
  cutAll,
  cutForSearch,
  cutHMM,
  cutSmall,
  tag,
  extract,
  insertUserWord,
  find,
  isJiebaReady,
  type Tagged,
  type Keyword,
  type PrepareJiebaOptions,
} from "react-native-jieba";
export { tokenize, type Token } from "./tokenize.ts";
export { ensureJiebaReady, warmJieba } from "./ensure-jieba-ready.ts";

// NOTE: jieba is intentionally *not* warmed at module scope. The wasm binary
// (`jieba_rs_wasm_bg.wasm`, served at `JIEBA_WASM_PUBLIC_URL`) is ~3 MB, and
// eagerly warming here meant every web page that transitively imports this
// wrapper fetched it on load — even pages that never segment. Consumers must
// instead `await ensureJiebaReady()` before any synchronous `cut`/`tag`/etc.
// call (those throw until the wasm instance is loaded), so the binary is only
// requested when jieba is actually used. Call `warmJieba()` yourself to
// pre-warm without awaiting.
